// Real KIKI photos hosted on Google Drive (public "anyone with link").
// Embedded via Drive's thumbnail endpoint which allows hotlinking.
export const GALLERY_IDS = [
  "1kubBRHjkNpZzyC7xLNakMQqgy-ZJL9jI",
  "1tSY-VUVYt03s4b8ndq_S5rTKM9H5HUtO",
  "1tnf_0b8cHWu-u-K2HB-R6TkU4KbFsKUf",
  "1wEQ6fByR1TGI6A_DXah-LlKRuLDbQZ72",
  "1Tg8KYdH0gQrEa6imsMma7u3_CN6sGvKA",
  "1fKH5BgMBLuOiaNjzs68Qb9ibtDCscmC9",
  "1iWSY828SzY6sh0V7uy5KgMsH-gB6oIGn",
  "186wGE-c4d85DElfuQyNVMi44r9Zswtvz",
  "1Z90bxIjudXVI9YKCbK5uBpej85Djlgjz",
  "1dWw5cutYajkmv5T-rKT9iQpOkvWxV01V",
  "1N82r8NceAxQq-V3hEUt2MKPdolA0u6l4",
  "1oLMB3Fug9isZvBVjqEY2y681HpMoJMLr",
  "1by-Xw6CR6JZ4dJofLsPhSDFkMhS-4e2X",
  "1JmLavTwW1mK1uiLg62uKW88UjpEcHxfk",
  "1VB0G6q5o1Zd3kX3cObS6KpzD3wYQm0SJ",
  "1cYElMMhD0iSe-bayMCf9INcMstS2n0TG",
  "1_xFaEnwV80FTxtGIRM3zCKwIBYYsi-Zh",
  "1nzHem7zDLZLS_JAF4ufL3jfaa76zBvUe",
  "1Qsk15Vj_cj7A8HOSe30iQV_V66f60Qbk",
  "1_jSOdzT7LCg6sdfnWz6M78h7jYgISN63",
  "18cpuGXsrlpvZLR_STDZQludFHwMkiiu5",
  "1x4p4l9RQge7O_d9jjPYaWtd2QVrD5JYJ",
  "1X4AEiSm5-gw9xHsXh-G6aCpOD4xwf_58",
  "1Pm61ha_TfhZvGeXMNDxS-JCeKjf4zONh",
  "11MIRkNPTftxs9dd6VeGxUj_6d04gHodV",
  "1btedoBfFhl_k40WKg284KtIXp5p2c4pK",
  "1DKkwEBAGw10wPoZEllv-11b0yOSLBQym",
  "10rMYpdAl3Do5-jshLJG3BgQ7cujQFLnF",
  "1xPxSawvQgf8S_eDKxtsH3temvCiPW60p",
  "1ikBnFFi5YtEgCZypX1Gk95b_OPpo_MuX",
  "1-Uq02R8HSnEEN7p2Wl8JASzurE_kWtxc",
  "1aWGiEM2nnypwm8BJ19r4qYIJU534PPGB",
  "11qzEhJZM5pwsUEEBHSUQ4cFT3WzU4Zst",
  "1l0yIUp6sO3MQytXmONAhsfLWvVovYo4J",
  "1e68vcSqN1qO4z-dy29BI7UaYOT9XY9a0",
  "1ndg8FKH20jtfTAOgL24aJXtbQzxKphwU",
];

export const driveImg = (id, w = 800) =>
  `https://drive.google.com/thumbnail?id=${id}&sz=w${w}`;
